
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ProfileEditionFunctionalError,
  UpdateAboutSectionRequest,
  UpdateHeaderSectionRequest,
} from '../models';
import {
    ProfileEditionFunctionalErrorFromJSON,
    ProfileEditionFunctionalErrorToJSON,
    UpdateAboutSectionRequestFromJSON,
    UpdateAboutSectionRequestToJSON,
    UpdateHeaderSectionRequestFromJSON,
    UpdateHeaderSectionRequestToJSON,
} from '../models';

export interface UpdateAboutSectionOperationRequest {
    profileId: string;
    updateAboutSectionRequest: UpdateAboutSectionRequest;
}

export interface UpdateHeaderSectionOperationRequest {
    profileId: string;
    updateHeaderSectionRequest: UpdateHeaderSectionRequest;
}

/**
 * 
 */
export class ProfileEditionApi extends runtime.BaseAPI {

    /**
     * Update about section of given profile (description, languages, industry, etc.)
          */
    async updateAboutSectionRaw(requestParameters: UpdateAboutSectionOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling updateAboutSection().'
            );
        }

        if (requestParameters['updateAboutSectionRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAboutSectionRequest',
                'Required parameter "updateAboutSectionRequest" was null or undefined when calling updateAboutSection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/profile/api/profiles/{profileId}/about`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAboutSectionRequestToJSON(requestParameters['updateAboutSectionRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update about section of given profile (description, languages, industry, etc.)
          */
    async updateAboutSection(requestParameters: UpdateAboutSectionOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAboutSectionRaw(requestParameters, initOverrides);
    }

    /**
     * Update header section of given profile (job title, daily rate, experience level, etc.)
          */
    async updateHeaderSectionRaw(requestParameters: UpdateHeaderSectionOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling updateHeaderSection().'
            );
        }

        if (requestParameters['updateHeaderSectionRequest'] == null) {
            throw new runtime.RequiredError(
                'updateHeaderSectionRequest',
                'Required parameter "updateHeaderSectionRequest" was null or undefined when calling updateHeaderSection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/profile/api/profiles/{profileId}/header`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateHeaderSectionRequestToJSON(requestParameters['updateHeaderSectionRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update header section of given profile (job title, daily rate, experience level, etc.)
          */
    async updateHeaderSection(requestParameters: UpdateHeaderSectionOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateHeaderSectionRaw(requestParameters, initOverrides);
    }

}
